import { t } from '../i18n';
import { iconImg } from '../ui/icons';

/** Circular “?” control that opens a specific help topic. */
export function createHelpTip(topicId: string): HTMLButtonElement {
  const tip = document.createElement('button');
  tip.type = 'button';
  tip.className = 'help-tip';
  tip.setAttribute('data-help-topic', topicId);
  tip.setAttribute('data-i18n-aria-label', 'help.tip');
  tip.setAttribute('data-i18n-title', 'help.tip');
  tip.setAttribute('aria-label', t('help.tip'));
  tip.title = t('help.tip');
  tip.textContent = '?';
  return tip;
}

/** Header-style button that opens help (search focused). */
export function createHelpOpenButton(): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'icon-button help-open-button';
  button.setAttribute('data-help-open', '');
  button.setAttribute('data-i18n-aria-label', 'help.openAria');
  button.setAttribute('aria-label', t('help.openAria'));
  button.append(iconImg('help-circle', 18));
  return button;
}

/** Compact text button for pages without the app header. */
export function createHelpOpenTextButton(): HTMLButtonElement {
  const button = document.createElement('button');
  button.type = 'button';
  button.className = 'button ghost help-open-text';
  button.setAttribute('data-help-open', '');
  button.innerHTML = `<span data-i18n="help.title"></span>`;
  return button;
}
